import { modalController, ModalOptions, toastController, ToastOptions } from '@ionic/core';

// @todo - this is showing as a large modal it should be sw-small-modal with a modal-wrapper 
export async function showFavoritedToast() {
  const modalOptions: ModalOptions = {
    backdropDismiss: false,
    component: 'sw-favorited-toast',
  };
  const modal = await modalController.create(modalOptions);
  await modal.present();
  setTimeout(() => modal.dismiss(), 1500);
}

export async function presentToast() {
  const options: ToastOptions = {
    message: "Added to My Favorites",
    position: 'top',
    duration: 1500,
    color: 'dark',
  };
  const toast = await toastController.create(options);
  return await toast.present();
}